import { createHttpRequest } from '@/common/http';

/**
 * 获取资讯类型
 * @param {Object} params
 * @return {Promise}
 */
export function getType(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取腾讯云秘钥
 *  @param {Object} params
 * @return {Promise}
 */
export function yunFun(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取新闻列表
 * @param {Object} params
 * @return {Promise}
 */
export function getInfoListShow(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}

/**
 * 获取视频类型
 * @param {Object} params
 * @return {Promise}
 */
export function getVideoType(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}

/**
 * 获取视频列表
 * @param {Object} params
 * @return {Promise}
 */
export function getVideoList(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}

/**
 * 获取热点资讯
 * @param {Object} params
 * @return {Promise}
 */
export function getInfoHot(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}

/**
 * 获取资讯详情
 * @param {Object} params
 * @return {Promise}
 */
export function getInfonews(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取视频详情
 * @param {Object} params
 * @return {Promise}
 */
export function getVod(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: {
      action: 'news.vod.getVod',
      ...params,
    },
  });
}

/**
 * 获取活动类型
 * @param {Object} params
 * @return {Promise}
 */
export function getactType(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}

/**
 * 获取活动图片
 * @param {Object} params
 * @return {Promise}
 */
export function getCultureList(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 更新活动图片
 *
 * @export
 * @param {any} [params={}]
 * @returns
 */
export function updateCulture(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取岗位类别
 * @param {Object} params
 * @return {Promise}
 */
export function getJobTypeList(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取岗位
 * @param {Object} params
 * @return {Promise}
 */
export function getJobList(params) {
  return createHttpRequest({
    entry: 'portal/Portal/access',
    data: params,
  });
}
/**
 * 获取轮播大图
 * @param {Object} params
 * @return {Promise}
 */
export function getCaoler(params) {
  return createHttpRequest({
    entry: 'pic/Carousel/selectCarousel',
    data: params,
  });
}
/**
 * 获取案例类型
 * @param {Object} params
 * @return {Promise}
 */
/***
 * 案例类型列表查询
 * @param {any} [params={}]
 * @returns
 */
export function getcaseType(params) {
  return createHttpRequest({
    entry: 'sys/Code/getCode',
    data: params,
  });
}
/***
 * 资讯列表查询
 * @param {any} [params={}]
 * @returns
 */
export function getcase(params) {
  return createHttpRequest({
    entry: 'cases/CaseShow/getCaseShow',
    data: params,
  });
}

/**
 * 产品类型树查询
 * @param {any} [params={}]
 * @returns
 */
export function getProTree(params) {
  return createHttpRequest({
    entry: 'product/ProductType/getProductTypeTree',
    data: params,
  });
}

/**
 * 产品分类查询
 * @param {any} [params={}]
 * @returns
 */
export function getProClass(params) {
  return createHttpRequest({
    entry: 'product/ProductShow/getProByType',
    data: params,
  });
}
/**
 * 获取置顶资讯列表
 * @param {any} [params={}]
 * @returns
 */
export function getsettopList(params) {
  return createHttpRequest({
    entry: 'news/Info/getInfoListShow',
    data: params,
  });
}
